import { render, staticRenderFns } from "./DogDetail.vue?vue&type=template&id=0f242fe4&scoped=true"
import script from "./DogDetail.vue?vue&type=script&lang=js"
export * from "./DogDetail.vue?vue&type=script&lang=js"
import style0 from "./DogDetail.vue?vue&type=style&index=0&id=0f242fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f242fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VSwitch})
